import OpenShiftLaborLawWarning from "./OpenShiftLaborLawWarning";
import React, { useEffect } from "react";
import ShiftInputsModal from "./ShiftInputsModal";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import OpenShiftInputsModal from "./OpenShiftInputsModal";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import useAutoScroll from "../../../../helpers/useAutoScroll";
import {
  getCardColor,
  getCardColor2,
  getRoleType,
  get_t_str_shortened,
  business_decline_suffix,
} from "../../../../helpers/helpers";

function OpenShiftCard(props) {
  // Auto-scroll hook - Add this
  const { startDragging, stopDragging } = useAutoScroll();

  // Shows modal when set to true
  const [open, setOpen] = React.useState(false);

  const [showActionButtons, setShowActionButtons] = React.useState(false);
  //const [showPasteButton, setShowPasteButton] = React.useState(false);
  const [showCopiedCheck, setShowCopyCheck] = React.useState(false);

  // Shows the check when they have successfully cut a shift when true
  const [showCutCheck, setShowCutCheck] = React.useState(false);

  // Function for opening the modal
  const handleOpen = () => {
    // console.log(props.shift_info);
    setOpen(!props.locked_mode);
  };

  // Function for closing the modal
  const handleClose = () => {
    setOpen(false);
    props.setSaveShiftFinished(false);
  };

  // Function for handling right-click context menu
  const handleContextMenu = (event) => {
    event.preventDefault();
    if (showActionButtons) {
      props.setCopiedShift(null);
      setShowActionButtons(false);
    } else {
      setShowActionButtons((prevState) => !prevState);
    }
  };

  // Handle copy in copy and paste
  const handleCopy = (shift) => {
    if (showCopiedCheck === false) {
      shift["copy_type"] = "copy";
      props.setCopiedShift(shift);
      setShowCopyCheck(true);
      setShowCutCheck(false);
    } else {
      props.setCopiedShift(null);
      setShowCopyCheck(false);
      setShowCutCheck(false);
    }
  };

  const handleCut = (shift) => {
    if (showCutCheck === false) {
      shift["copy_type"] = "cut";
      props.setCopiedShift(shift);
      setShowCutCheck(true);
      setShowCopyCheck(false);
    } else {
      props.setCopiedShift(null);
      setShowCutCheck(false);
      setShowCopyCheck(false);
    }
  };

  useEffect(() => {
    if (props.copiedShift !== props.shift_info) {
      setShowActionButtons(false);
      setShowCopyCheck(false);
    }
  }, [props.copiedShift]);

  // Function to get role name
  const getRoleName = (role_id, role_lookups) => {
    const role_info = role_lookups.filter((r) => r.id === role_id);
    if (role_info.length > 0) {
      return role_info[0]["role_name"];
    } else {
      return null;
    }
  };

  // const shiftCardColor = getCardColor(
  //   props.shift_info.role_id,
  //   props.role_names,
  //   props.role_types,
  //   props.locked_mode
  // );

  const shiftCardColor = getCardColor2(
    props.shift_info.role_id,
    props.role_names,
    props.locked_mode,
    true
  );

  // Updated handleDragStart to use auto-scroll
  const handleDragStart = (e, shift) => {
    props.setCopiedShift(shift);
    startDragging(); // Start auto-scroll functionality
  };

  // Updated handleDragEnd to stop auto-scroll
  const handleDragEnd = (e) => {
    stopDragging(); // Stop auto-scroll functionality
    props.setCopiedShift(null);
  };

  const minimizeMode = true;
  const breakSummary = [1, 2]
    .map((breakIndex) => {
      const length =
        breakIndex === 1
          ? props.shift_info.break_length
          : props.shift_info.break_length_2;
      const start =
        breakIndex === 1
          ? props.shift_info.break_start
          : props.shift_info.break_start_2;
      if (!(length > 0)) {
        return null;
      }
      return `${props.get_t_str(start)} (${length}hr)`;
    })
    .filter(Boolean)
    .join(", ");

  return (
    <div className="w-full min-w-full relative">
      {!showActionButtons ? (
        <div
          onClick={handleOpen}
          className={
            "w-full min-w-full flex overflow-hidden bg-white rounded-lg shadow-md " +
            (props.weekly_or_daily === "weekly" ? "max-w-sm" : "")
          }
          onContextMenu={(event) => handleContextMenu(event)}
          draggable={!props.locked_mode}
          onDragStart={(e) => handleDragStart(e, props.shift_info)}
          onDragEnd={handleDragEnd} // Updated to use new handleDragEnd
        >
          <div
            className={`w-full flex items-center h-7 px-2 text-white relative ${shiftCardColor}`}
          >
            <div className="mx-1 w-full">
              {props.weekly_or_daily === "weekly" ? (
                <div>
                  <p className={`flex items-center gap-1.5 text-xs ${props.windowWidth <= 1279 ? "font-normal" : "font-bold"}`}>
                    {props.shift_info?.is_publishable === true && (
                      <Tooltip title="Unpublished. Not in the shift pool yet." arrow>
                        <span
                          aria-label="Unpublished"
                          className="inline-block w-[7px] h-[7px] rounded-full border-[1.5px] border-white shrink-0"
                        />
                      </Tooltip>
                    )}
                    {get_t_str_shortened(props.shift_info.shift_start) +
                      " - " +
                      get_t_str_shortened(props.shift_info.shift_end) +
                      business_decline_suffix(props.shift_info)}
                  </p>
                  {!minimizeMode && (
                    <p className="text-xxxs">
                      {breakSummary
                        ? "Break: " + breakSummary
                        : "Break: None"}
                    </p>
                  )}
                  {getRoleName(props.shift_info.role_id, props.role_names)
                    ? !minimizeMode && props.windowWidth > 1279 && (
                        <p className="text-xxxs">
                          {getRoleName(
                            props.shift_info.role_id,
                            props.role_names
                          )}
                        </p>
                      )
                    : !minimizeMode && (
                        <p className="text-xxxs">
                          {props.shift_info.hours} hrs
                        </p>
                      )}
                </div>
              ) : (
                <div className="h-full flex items-center gap-4 pl-3">
                  <p className={`flex items-center gap-1.5 text-xs ${props.windowWidth <= 1279 ? "font-normal" : "font-bold"}`}>
                    {props.shift_info?.is_publishable === true && (
                      <Tooltip title="Unpublished. Not in the shift pool yet." arrow>
                        <span
                          aria-label="Unpublished"
                          className="inline-block w-[7px] h-[7px] rounded-full border-[1.5px] border-white shrink-0"
                        />
                      </Tooltip>
                    )}
                    {get_t_str_shortened(props.shift_info.shift_start) +
                      " - " +
                      get_t_str_shortened(props.shift_info.shift_end) +
                      business_decline_suffix(props.shift_info)}
                  </p>
                  {props.windowWidth > 1279 && getRoleName(props.shift_info.role_id, props.role_names) ? (
                    <p className="text-xs">
                      {getRoleName(props.shift_info.role_id, props.role_names)}
                    </p>
                  ) : (
                    <p className="text-xs">{props.shift_info.hours} hrs</p>
                  )}
                </div>
              )}
            </div>
            <OpenShiftLaborLawWarning
              shift={props.shift_info}
              violations={props.laborLawViolations}
              showActualTimes={props.showActualTimes}
            />
            {props.weekly_or_daily === "weekly" &&
              props.shift_info?.pending_pickup_user_ids?.length > 0 && (
                <Tooltip
                  title={`${props.shift_info.pending_pickup_user_ids.length} pickup request${
                    props.shift_info.pending_pickup_user_ids.length === 1 ? "" : "s"
                  }`}
                  arrow
                >
                  <span className="ml-auto inline-flex items-center gap-0.5 rounded-full bg-white/25 px-1.5 text-xxs font-bold shrink-0">
                    {props.windowWidth > 1279 && (
                      <PeopleOutlineIcon style={{ fontSize: "12px" }} />
                    )}
                    {props.shift_info.pending_pickup_user_ids.length}
                  </span>
                </Tooltip>
              )}
            {props.shift_info?.note &&
              <div className="absolute right-1 -top-1.5">
                <Tooltip title={props.shift_info?.note}>
                  <NoteAltIcon sx={{ fontSize: "8px" }}/>
                </Tooltip>
              </div>
            }
          </div>
        </div>
      ) : (
        <div
          // onClick={handleOpen}
          className={
            "w-full min-w-full flex overflow-hidden bg-white rounded-lg shadow-md " +
            (props.weekly_or_daily === "weekly" ? "max-w-sm" : "")
          }
          onContextMenu={(event) => handleContextMenu(event)}
          // draggable={!props.locked_mode}
          // onDragStart={(e) => handleDragStart(e, props.shift_info)}
          // onDragEnd={(e) => props.setCopiedShift(null)}
        >
          <div
            className={`w-full flex items-center h-7 px-2 text-white relative ${shiftCardColor}`}
          >
            <div className="mx-1 w-full">
              <div className="w-full flex items-center justify-between space-x-1.5">
                <Tooltip title={"Edit or add shift"} arrow>
                  <div
                    className="flex-1 h-8 bg-slate-800 opacity-50 hover:bg-slate-700 flex items-center justify-center"
                    onClick={handleOpen}
                  >
                    <EditIcon style={{ fontSize: "14px" }} />
                  </div>
                </Tooltip>
                <Tooltip
                  title={
                    !showCopiedCheck
                      ? "Copy shift"
                      : "Shift copied. When you paste this shift to another slot, the original will remain"
                  }
                  arrow
                >
                  <div
                    className="flex-1 h-8 bg-slate-800 opacity-50 hover:bg-slate-700 flex items-center justify-center"
                    onClick={() => handleCopy(props.shift_info)}
                  >
                    {!showCopiedCheck ? (
                      <ContentCopyIcon style={{ fontSize: "14px" }} />
                    ) : (
                      <CheckIcon style={{ fontSize: "20px" }} />
                    )}
                  </div>
                </Tooltip>
                <Tooltip
                  title={
                    !showCutCheck
                      ? "Cut shift"
                      : "Shift cut. When you paste this shift to another slot, the original will disappear"
                  }
                  arrow
                >
                  <div
                    className="flex-1 h-8 bg-slate-800 opacity-50 hover:bg-slate-700 flex items-center justify-center"
                    onClick={() => handleCut(props.shift_info)}
                  >
                    {!showCutCheck ? (
                      <ContentCutIcon style={{ fontSize: "14px" }} />
                    ) : (
                      <CheckIcon style={{ fontSize: "20px" }} />
                    )}
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {showActionButtons && !showCopiedCheck && (
        <div
          className={`absolute ${
            minimizeMode ? "-left-6 bottom-1" : "-left-7 bottom-5"
          }`}
        >
          <Tooltip title={"Copy Shift"}>
            <IconButton onClick={() => handleCopy(props.shift_info)}>
              <ContentCopyIcon style={{ fontSize: "14px" }} />
            </IconButton>
          </Tooltip>
        </div>
      )}
      {showCopiedCheck && (
        <div
          className={`absolute ${
            minimizeMode ? "-left-6 bottom-1" : "-left-7 bottom-5"
          }`}
        >
          <Tooltip title={"Shift Copied!"}>
            <IconButton disabled={true}>
              <CheckIcon style={{ fontSize: "14px" }} />
            </IconButton>
          </Tooltip>
        </div>
      )} */}
      <OpenShiftInputsModal
        paidBreakInputsEnabled={props.paidBreakInputsEnabled}
        restBreakRegulation={props.restBreakRegulation}
        open={open}
        handleClose={handleClose}
        shift_info={props.shift_info}
        shifts_info={[props.shift_info]}
        p={props.p}
        new_shift={false}
        addShift={props.addShift}
        date_name={props.date_name}
        get_t_str={props.get_t_str}
        role_names={props.role_names}
        getRoleName={getRoleName}
        getRoleType={getRoleType}
        saveShiftFinished={props.saveShiftFinished}
        setSaveShiftFinished={props.setSaveShiftFinished}
        d={props.d}
        role_types={props.role_types}
        businessWeekStartDayIndex={props.businessWeekStartDayIndex}
        start_qhnum={props.start_qhnum}
        schedule_day_end_qhnum={props.schedule_day_end_qhnum}
        defaultBreakLengthHours={props.defaultBreakLengthHours}
        breakRequiredWhenShiftLengthExceeds={
          props.breakRequiredWhenShiftLengthExceeds
        }
        secondBreakShiftLengthThreshold={
          props.secondBreakShiftLengthThreshold
        }
        businessDeclineShiftOptionEnabled={
          props.businessDeclineShiftOptionEnabled
        }
        store_team_member_weekly_info={props.store_team_member_weekly_info}
        existingShift={true}
      />
    </div>
  );
}

export default OpenShiftCard;
